<div class="login-footerv2">
  <span class="need-help" tabindex="0"
    ><a (click)="gotoContactUs()">{{ "login.needHelp" | translate }}</a>
  </span>
  Copyright © {{ copyrightYear }} Accenture
</div>
